import { render, staticRenderFns } from "./CourseResources.vue?vue&type=template&id=e4c17750&scoped=true&"
import script from "./CourseResources.vue?vue&type=script&lang=js&"
export * from "./CourseResources.vue?vue&type=script&lang=js&"
import style0 from "./CourseResources.vue?vue&type=style&index=0&id=e4c17750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c17750",
  null
  
)

export default component.exports